import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from '../finance/shared';

const RealEstateFinancing = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [propertyValue, setPropertyValue] = useState('500.000,00');
  const [downPayment, setDownPayment] = useState('100.000,00');
  const [rate, setRate] = useState('1,00');
  const [years, setYears] = useState('30');
  const [system, setSystem] = useState('sac');
  const [result, setResult] = useState<any>(null);

  const calculate = () => {
    const property = parseFloat(parseBrazilianNumber(propertyValue)) || 0;
    const entry = parseFloat(parseBrazilianNumber(downPayment)) || 0;
    const monthlyRate = parseFloat(parseBrazilianNumber(rate)) / 100;
    const totalMonths = parseInt(years) * 12;

    if (property <= 0 || totalMonths <= 0) return;
    const financed = property - entry;

    let monthlyPayment, totalInterest;
    if (system === 'sac') {
      const principalPart = financed / totalMonths;
      monthlyPayment = principalPart + (financed * monthlyRate);
      totalInterest = financed * monthlyRate * ((totalMonths + 1) / 2);
    } else {
      monthlyPayment = financed * (monthlyRate * Math.pow(1 + monthlyRate, totalMonths)) / (Math.pow(1 + monthlyRate, totalMonths) - 1);
      totalInterest = (monthlyPayment * totalMonths) - financed;
    }

    const totalPaid = financed + totalInterest;
    setResult({ financed, monthlyPayment, totalInterest, totalPaid });
    onResultChange([
      { label: 'Valor Financiado', value: `R$ ${financed.toLocaleString('pt-BR')}` },
      { label: 'Total de Juros', value: `R$ ${totalInterest.toLocaleString('pt-BR')}` },
      { label: 'Total a Pagar', value: `R$ ${totalPaid.toLocaleString('pt-BR')}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          <FormField label="Valor Imóvel" value={propertyValue} onChange={setPropertyValue} isNumeric required type="text" />
          <FormField label="Entrada" value={downPayment} onChange={setDownPayment} isNumeric required type="text" />
          <FormField label="Anos" value={years} onChange={setYears} isNumeric required type="text" />
        </div>
        <div className="flex justify-center mb-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:scale-105 transition-all">Simular</button>
        </div>
        {result && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <ResultCard title="Financiado" value={`R$ ${result.financed.toLocaleString('pt-BR')}`} color="indigo" />
            <ResultCard title="1ª Parcela" value={`R$ ${result.monthlyPayment.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="emerald" />
            <ResultCard title="Total Juros" value={`R$ ${result.totalInterest.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="amber" />
            <ResultCard title="Custo Total" value={`R$ ${result.totalPaid.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="rose" />
          </div>
        )}
      </div>
    </div>
  );
};

export default RealEstateFinancing;
